export default __webpack_public_path__ + "static/illustration-do-73edbf68dab0355f644e567d4dcb3b86.png";